import { render, staticRenderFns } from "./FifoReport.vue?vue&type=template&id=69812816&"
import script from "./FifoReport.vue?vue&type=script&lang=ts&"
export * from "./FifoReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69812816')) {
      api.createRecord('69812816', component.options)
    } else {
      api.reload('69812816', component.options)
    }
    module.hot.accept("./FifoReport.vue?vue&type=template&id=69812816&", function () {
      api.rerender('69812816', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/reports/FifoReport.vue"
export default component.exports